// src/views/ImageFullView.js
import React from "react";
import { useParams, Link } from "react-router-dom";
import { useSelector } from "react-redux";
import { Title } from "../theme";

const fullImageStyle = {
  width: "100%",
  height: "auto",
  objectFit: "contain",
  display: "block",
  margin: "0 auto",
  maxHeight: "100vh",
};

const containerStyle = {
  padding: "0rem",
  backgroundColor: "black",
  minHeight: "100vh",
  color: "white",
  textAlign: "center",
};

const ImageFullView = () => {
  const { id } = useParams();
  const memes = useSelector((state) => state.data.memes);

  if (!memes || memes.length === 0) {
    return <div style={containerStyle}>Loading...</div>;
  }

  const meme = memes.find((m) => m._id === id);

  if (!meme) {
    return <div style={containerStyle}>Image not found.</div>;
  }

  return (
    <div style={containerStyle}>
      <img src={meme.img} alt={meme.description || id} style={fullImageStyle} />
    </div>
  );
};

export default ImageFullView;
